import React, { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import Typography from 'LuxKit/Typography/Typography'

const SCROLL_NEAR_THRESHOLD = 500

interface OfferListInfiniteScrollProps {
  onLoadMore: () => void
  isLoading?: boolean
  hasMore?: boolean
  endMessage?: string
}

function OfferListInfiniteScroll(props: OfferListInfiniteScrollProps) {
  const {
    onLoadMore,
    isLoading = false,
    hasMore = true,
    endMessage,
  } = props

  const [buttonRef, isInView] = useInView({
    rootMargin: `${SCROLL_NEAR_THRESHOLD}px`,
  })

  useEffect(() => {
    if (isInView && hasMore && !isLoading) {
      onLoadMore()
    }
  }, [isInView, hasMore, isLoading, onLoadMore])

  return (
    <VerticalSpacer gap={16} ref={buttonRef}>
      {isLoading && <LoadingIndicator inline />}
      {!hasMore && (
        <Typography align="center" colour="neutral-two">
          {endMessage}
        </Typography>
      )}
    </VerticalSpacer>
  )
}

export default OfferListInfiniteScroll
